<template>
  <div>
    <div class="fin-panel" >

      <van-cell-group>
        <van-field
            :required=true
            :border=false
            readonly
            clickable
            label="日期"
            :value="formModel.finDate"
            placeholder="请选择"
            @click="showDatePicker = true"
        />
        <van-popup v-model="showDatePicker" position="bottom">
          <van-datetime-picker
              v-model="pickDate"
              type="date"
              :min-date="minDate"
              :max-date="maxDate"
              @cancel="showDatePicker = false"
              @confirm="onDateConfirm"
          />
        </van-popup>
      </van-cell-group>
      <van-cell-group>
        <van-field
            readonly
            :required=true
            clickable
            label="时间"
            :value="formModel.finTime"
            placeholder="请选择"
            @click="showTimePicker = true"
        />
        <van-popup v-model="showTimePicker" position="bottom">
          <van-datetime-picker
              v-model="pickTime"
              type="time"
              :min-hour="0"
              :max-hour="24"
              @cancel="showTimePicker = false"
              @confirm="onTimeConfirm"
          />
        </van-popup>
      </van-cell-group>
      <van-cell-group>
        <van-row type="flex" >
          <van-col span="18" >
            <van-field  readonly
                        type="text" label="金额"
                        placeholder="请录入金额"
                        :required=true
                        clickable
                        :value="tmpAmount"
                        @touchstart.native.stop="showKeyboard = true"
            />
            <van-number-keyboard
                :show="showKeyboard"
                v-model="tmpAmount"
                :extra-key="[ '.','+']"
                theme="custom"
                close-button-text="完成"
                @blur="showKeyboard = false"
            />
          </van-col>
          <van-col span="6">
            <van-cell  :value="formModel.amount" />
          </van-col>

        </van-row>

      </van-cell-group>
      <van-cell-group>
        <van-field
            readonly
            clickable
            label="归属/分类"
            :value="belongFinType"
            placeholder="请选择"
            @click="showPicker = true"
        />
        <van-popup v-model="showPicker" position="bottom" >
          <van-picker
              show-toolbar title="归属/分类" ref="belongPicker"
              :columns="belongFinTypes"
              value-key="attrName"
              @cancel="showPicker = false"
              @confirm="onConfirm"
          />
        </van-popup>

      </van-cell-group>
      <van-cell-group >
        <van-field
            readonly
            clickable
            label="类型/明细"
            :value="sortAndDetail"
            placeholder="请选择"
            @click="showSortPicker = true"

        />
        <!--  :lazy-render="false" 未弹出组件时渲染     -->
        <van-popup v-model="showSortPicker" position="bottom" :lazy-render="false">
          <van-picker show-toolbar title="类型/明细" ref="sortPicker"
                      :columns="sortAndDetails"
                      value-key="attrName"
                      @cancel="showSortPicker = false"
                      @confirm="onSortConfirm"/>
        </van-popup>
      </van-cell-group>

      <van-cell-group v-if="isPay">
        <van-field
            readonly
            clickable
            label="付款人/方式"
            :value="payer"
            placeholder="请选择"
            @click="showPayerPicker = true"
        />
        <van-popup v-model="showPayerPicker" position="bottom">
          <van-picker
              show-toolbar title="付款人/方式" ref="payerPicker"
              :columns="payers"
              value-key="attrName"
              @cancel="showPayerPicker = false"
              @confirm="onPayerConfirm"
          />
        </van-popup>

      </van-cell-group >
      <!--     如果是支出,并且使用零用钱卡结算时,才进行显示       -->
      <van-cell-group v-if="isPay && formModel.payMode == busiConsts.PAY_MODE_POCKET">

        <van-row type="flex" >
          <van-col span="13" >
            <van-field label="零用钱" :value="pocketMoney" readonly />
          </van-col>
          <van-col span="11">
            <van-field name="switch" label="零用钱结算">
              <template #input>
                <van-switch v-model="formModel.usePM" size="13" />
              </template>
            </van-field>
          </van-col>

        </van-row>


      </van-cell-group>
      <van-cell-group v-if="isPay && tags.length > 0">
        <van-row type="flex">
          <van-col span="8" >
            <van-field label="标签" />
          </van-col>
          <van-col span="16" >
            <span v-for="tag in tags" :key="tag.attrId">
                <van-tag  plain   type="default"  style="margin-right:5px" @click="clickTag(tag,$event)">{{tag.attrName}}</van-tag>
            </span>
          </van-col>
        </van-row>
      </van-cell-group>

      <van-cell-group >
        <van-row>
          <van-col span="13" >
            <van-field
                readonly
                clickable
                label="账单类型"
                :value="billType"
                placeholder="请选择"
                @click="showBillTypePicker = true"

            />
            <van-popup v-model="showBillTypePicker" position="bottom">
              <van-picker show-toolbar title="账单类型" ref="billTypePicker"
                          :columns="billTypes"
                          value-key="attrName"
                          @cancel="showBillTypePicker = false"
                          @confirm="onBillTypeConfirm"/>
            </van-popup>
          </van-col>
          <van-col span="11" >
            <van-field name="switch" label="日常统计">
              <template #input>
                <van-switch v-model="formModel.statisticsFlag" size="13" />
              </template>
            </van-field>
          </van-col>
        </van-row>
      </van-cell-group>

      <van-cell-group>
        <van-field
            v-model="formModel.remark"
            rows="2"
            autosize
            label="备注"
            type="textarea"
            maxlength="50"
            placeholder="请输入备注"
            show-word-limit
        />

      </van-cell-group>

      <van-button style="margin-top: 10px;" type="primary"
                  block round color="#fe7844" :loading="isLoading"
                  loading-text="提交中..."
                  @click="submitForm">提交</van-button>

      <van-button style="margin-top: 10px;" type="info" plain v-show="checkUser()"
                  block round  :loading="isSettlementAccount"
                  loading-text="轧账中..."
                  @click="settlementAccount">轧账</van-button>
    </div>
  </div>
</template>

<script>
import * as DateUtil from '../../common/utils/dateUtil.js'
import * as MyApi from '../../api/URLApiAddr.js'
import * as BusiConsts from '../../common/BusiConsts.js'
import store from '@/store'

export default {
  name: 'MyFinance',
  components: {
  },
  data() {
    return {
      active: [],
      isLoading: false,
      busiConsts: BusiConsts,
      formModel:{
        finId: this.$route.params.finId,
        amount: Number,
        belong:'',
        finType:'',
        sort:'',
        sortDetail:'',
        payer:'',
        payMode: '',
        remark:'',
        inputDate: DateUtil.formatDate(new Date,'yyyy-MM-dd'),
        month: DateUtil.formatDate(new Date,'yyyy-MM'),
        finDate: DateUtil.formatDate(new Date,'yyyy-MM-dd'),
        finTime: DateUtil.formatDate(new Date,'hh:mm'),
        usePM:true,
        tagIds: [],
        billType: '',
        statisticsFlag: true
      },
      month:this.$route.params.month,
      pickDate:new Date(),
      showDatePicker:false,
      minDate: DateUtil.getMinDate(),
      maxDate: DateUtil.getMaxDate(),

      pickTime:DateUtil.formatDate(new Date,'hh:mm'),
      showTimePicker:false,
      showKeyboard:false,
      belongFinType: '',
      showPicker: false,
      sortAndDetail: '',
      showSortPicker: false,
      showPayerPicker: false,
      payer: '',
      payers: [],
      remark: '',
      belongFinTypes: [],
      sortAndDetails: [],
      pocketMoney:'0.00',
      isPay: true,
      tags: [],
      tagIds: new Set(),
      billType: '',
      billTypes: [],
      showBillTypePicker: false,
      isSettlementAccount: false,
      typesTags:{},
      tmpAmount: ''
    }
  },
  created:function() {
    if(!this.formModel.finId){
      this.initData()
    }else{
      this.initAlterData()
    }
    this.initTypesTag()
  },
  watch:{
    'formModel.payMode'() {
      let billTypes = this.billTypes[0].values;
      //非零用钱卡结算的其他支付方式都为分期支付
      if (this.busiConsts.PAY_MODE_POCKET == this.formModel.payMode) {
        let billType = billTypes[0];
        this.formModel.billType = billType.attrId
        this.billType = billType.attrName
      }else{
        let billType = billTypes[1];
        this.formModel.billType = billType.attrId
        this.billType = billType.attrName
      }
    },
    'tmpAmount'(){
      let data = this.tmpAmount.split("+")
      let allAmount = 0
      for(let i = 0 ; i < data.length ; i++){
        if(data[i] != ''){
          let amt = parseFloat(data[i])
          allAmount += amt
        }
      }
      this.formModel.amount = allAmount.toFixed(2)
    }
  },
  methods:{
    initData(){
      let user = store.state.sys.user;
      this.$axios.get(MyApi.QRY_ATTR_LIST).then((response) => {
        let blg = response.data.belong
        let ft = response.data.finType
        let pr = response.data.payer
        let payMode = response.data.payMode
        let bt = response.data.billType
        this.tags = response.data.tags

        this.belongFinTypes.push({values:blg});
        this.belongFinTypes.push({values:ft});

        let payerIndex = this.getPayerIndex(pr,user.userId);

        //赋值付款人和付款方式
        this.payers.push({values:pr,defaultIndex:payerIndex});
        this.payers.push({values:payMode});

        this.billTypes.push({values:bt});

        let sortDetails = response.data.sort
        this.sortAndDetails = sortDetails

        this.formModel.belong = blg[0].attrId
        this.formModel.finType = ft[0].attrId
        //付款人和付款方式
        this.formModel.payer = pr[payerIndex].attrId
        this.formModel.payMode = payMode[0].attrId

        this.belongFinType = blg[0].attrName + " " + ft[0].attrName
        //显示付款信息:付款人和付款方式
        this.payer = pr[payerIndex].attrName + " " + payMode[0].attrName

        this.formModel.sort = sortDetails[0].attrId
        this.formModel.sortDetail = sortDetails[0].children[0].attrId
        this.sortAndDetail = sortDetails[0].attrName + " " + sortDetails[0].children[0].attrName

        this.formModel.billType = bt[0].attrId
        this.billType = bt[0].attrName


        this.refreshPocketMoney(pr[payerIndex].attrId)
        //根据付款人,判断是否需要使用零用钱结算
        this.changePMButtomSelect(pr[payerIndex].attrId,payMode[0].attrId)
        //根据分类显示或者隐藏付款人
        this.hideOrShowPayer(ft[0].attrId)
        // console.log(response)
        // console.log(response.data.data)
      }).catch((error) => {

        this.$toast.fail("数据初始化异常"+error);
      })

    },
    initAlterData(){
      debugger
      let finId = this.formModel.finId
      let params = {finId:finId}
      //let thiz = this
      this.$axios.post(MyApi.QRY_FIN_DETAIL,params/*,options*/)
          // 请求成功后
          .then((response) => {

            let data = response.data;

            let blg = data.attrSepc.belong
            let ft = data.attrSepc.finType
            let pr = data.attrSepc.payer
            let bt = data.attrSepc.billType
            let payMode = data.attrSepc.payMode

            this.belongFinTypes.push({values:blg,defaultIndex:data.initIndex[0]});
            this.belongFinTypes.push({values:ft,defaultIndex:data.initIndex[1]});

            this.payers.push({values:pr,defaultIndex:data.initIndex[2]})
            this.payers.push({values:payMode,defaultIndex:data.initIndex[5]})
            this.billTypes.push({values:bt,defaultIndex:data.initIndex[3]})
            //角标4是在途账单的状态billStatus


            let sortDetails = data.attrSepc.sort

            let finance = data.finance
            this.belongFinType = finance.belongName + " " + finance.finTypeName
            this.sortAndDetail = finance.sortName + " " + finance.sortDetailName
            this.payer = finance.payerName + " " + finance.payModeName
            this.billType = finance.billTypeName

            let resDate = finance.inputDate.substr(0,10)
            this.formModel.finDate = resDate

            this.pickDate = DateUtil.stringToDate(resDate)

            this.formModel.finTime = finance.inputDate.substr(11,5)
            this.pickTime = finance.inputDate.substr(11,5)

            this.sortAndDetails = sortDetails

            this.formModel.finId = finance.finId;
            this.formModel.month = finance.month;
            this.formModel.amount = finance.amount + '';
            this.tmpAmount = finance.amount+'';
            this.formModel.belong = finance.belong + '';
            this.formModel.finType = finance.finType + '';
            this.formModel.inputDate = finance.inputDate + '';
            this.formModel.sort = finance.sort + '';
            this.formModel.sortDetail = finance.sortDetail + '';
            this.formModel.remark = finance.remark + '';
            this.formModel.payer = finance.payer + '';
            this.formModel.payMode = finance.payMode + '';
            this.formModel.billType = finance.billType + '';

            this.formModel.usePM = finance.usePM
            this.formModel.statisticsFlag = finance.statisticsFlag
            this.refreshPocketMoney(finance.payer)
            this.hideOrShowPayer(finance.finType)


          })
          .catch((err) => {
            console.log(err)
            this.$toast.fail("请求异常,请稍后再试");
          })

    },
    initTypesTag(){
      this.$axios.get(MyApi.QRY_TYPES_TAGS_LIST).then((resp) => {
        this.typesTags = resp.data;
      }).catch((err) => {
        console.log(err)
        this.$toast.fail("请求异常,请稍后再试");
      })
    },
    onConfirm(value,index) {
      this.formModel.belong = value[0].attrId;
      this.formModel.finType = value[1].attrId;
      //如果选择收入类型，隐藏付款人和零花钱
      this.hideOrShowPayer(value[1].attrId);
      //如果类型为收入时，默认选择收入分类
      this.changeSort(value[1].attrId);

      this.belongFinType = value[0].attrName + " " + value[1].attrName;
      this.showPicker = false
    },

    onSortConfirm(value) {

      let index = this.$refs.sortPicker.getIndexes()
      let sortIndex = index[0];
      let detailIndex = index[1];
      this.formModel.sort = this.sortAndDetails[sortIndex].attrId
      this.formModel.sortDetail = this.sortAndDetails[sortIndex].children[detailIndex].attrId
      this.sortAndDetail = value[0] + " " + value[1];
      this.showSortPicker = false;
    },
    onDateConfirm(value) {
      this.formModel.finDate = DateUtil.formatDate(value,'yyyy-MM-dd');
      this.formModel.month = DateUtil.formatDate(value,'yyyy-MM');
      this.showDatePicker = false;
    },
    onTimeConfirm(value) {
      this.formModel.finTime = value;
      this.showTimePicker = false;
    },
    onPayerConfirm(value,index){
      this.formModel.payer = value[0].attrId;
      this.formModel.payMode = value[1].attrId;
      //如果是靖宝的支出,或者非零用钱结算，默认不用零花钱支付
      this.changePMButtomSelect(value[0].attrId,value[1].attrId)
      // if(BusiConsts.BELONG_BAO == value[0].attrId ){
      //     this.formModel.usePM = false
      // }else{
      //     this.formModel.usePM = true
      // }

      this.payer = value[0].attrName + ' ' + value[1].attrName;
      this.refreshPocketMoney(value[0].attrId);

      this.showPayerPicker = false;
    },
    changePMButtomSelect(payer,payMode){
      if(BusiConsts.BELONG_BAO == payer || BusiConsts.PAY_MODE_POCKET != payMode){
        this.formModel.usePM = false
      }else{
        this.formModel.usePM = true
      }
    },
    submitForm() {
      this.isLoading = true
      // let params = this.model
      // thisVue.buttonDisabled = true
      //let toast = thisVue.showToast()

      debugger;
      let params = this.formModel
      //将set转为数组
      params.tagIds = [...this.tagIds]
      this.$axios.post(MyApi.FINANCE_SAVE_URL,params/*,options*/)

          // 请求成功后
          .then((data) => {
            //let data = response.data;
            if('200' == data.code){
              if(this.month){
                this.$router.push({ name:'finList',params:{month:this.month} })
              }
              this.formModel.amount = Number
              this.formModel.remark = ''
              this.tmpAmount = ''
              this.$toast.success(data.msg);
              this.refreshPocketMoney(this.formModel.payer)
            }
            this.formModel.finTime = DateUtil.formatDate(new Date,'hh:mm')
            this.isLoading = false
          })
          .catch((err) => {
            this.$toast.fail("请求异常,请稍后再试");
          })
    },
    onClickLeft() {
      if(this.month){
        this.$router.push({ name:'finList',params:{month:this.month} })
      }else{
        history.back();
      }
    },
    goToFinReport(){
      this.$router.push({ path:'/finReport'  })
    },
    refreshPocketMoney(roleId){
      if(roleId != undefined && roleId != null ) {
        let params = {"roleId": roleId}
        this.$axios.post(MyApi.QRY_POCKET_MONTY_URL, params/*,options*/)
            // 请求成功后
            .then((data) => {
              //let data = response.data;
              if ('200' == data.code) {
                this.pocketMoney = data.data.balance;
              }
            })
            .catch((err) => {
              this.$toast.fail("请求异常,请稍后再试");
            })
      }
    },
    //展示或者隐藏付款人
    hideOrShowPayer(finTypeId){
      //如果选择收入类型，隐藏付款人和零花钱
      if(BusiConsts.FIN_TYPE_INCOME == finTypeId){
        this.isPay = false
      }else{
        this.isPay = true
      }
    },
    //如果类型为收入，修改为收入类型
    changeSort(finTypeId){
      debugger

      if(BusiConsts.FIN_TYPE_INCOME == finTypeId){
        this.refreshSort(BusiConsts.SORT_INCOME,'')
      }else{
        this.refreshSort(BusiConsts.SORT_EAT,'')
      }
    },
    refreshSort(sortId,detailId){
      for(let i = 0 ; i < this.sortAndDetails.length ; i++){
        let tmpSort = this.sortAndDetails[i]
        if(sortId == tmpSort.attrId){
          let tmpDefaultInfo = this.sortAndDetails[0]
          //重置类型、明细数据;将数组进行位置调换
          this.$set(this.sortAndDetails, 0, tmpSort)
          this.$set(this.sortAndDetails, i, tmpDefaultInfo)
          // 如果明细有值，获取坐标
          let flag = 0;
          if(detailId != ''){
            let child = tmpSort.children
            for(let j = 0 ; j < child.length ; j++){
              if(child[j].attrId === detailId){
                flag = j
                break
              }
            }
          }

          //重置选择索引
          this.$refs.sortPicker.setIndexes([0,flag]);

          let sortName = tmpSort.attrName;
          let dfIndex = tmpSort.defaultIndex;
          let dtlName = tmpSort.children[flag].attrName;
          this.sortAndDetail = sortName + ' ' + dtlName
          //重新赋值表单数据
          this.formModel.sort = tmpSort.attrId
          this.formModel.sortDetail = tmpSort.children[flag].attrId
          this.$forceUpdate();
          break;
        }
      }
    },
    getPayerIndex(payers,userId){
      for(let i = 0 ; i < payers.length ; i++){
        let payer = payers[i];
        if(payer.attrId == userId){
          return i;
        }
      }
    },
    clickTag(tag,event){
      let dt = this.typesTags[tag.attrId]
      //如果没有default,说明是已经选中的标签
      if(event.target.className.indexOf('van-tag--default') === -1){
        //取消选中
        this.tagIds.delete(tag.attrId)
        event.target.classList.replace('van-tag--primary','van-tag--default')
        //没有对应标签、分类对应关系
        if(dt){
          this.refreshSort(BusiConsts.SORT_EAT,'')
        }

      }else{
        this.tagIds.add(tag.attrId)
        event.target.classList.replace('van-tag--default','van-tag--primary')
        //没有对应标签、分类对应关系
        if(dt){
          this.refreshSort(dt.typeId,dt.typeChildId)
        }
      }
    },
    onBillTypeConfirm(value){
      this.formModel.billType = value[0].attrId;
      this.billType = value[0].attrName ;
      this.showBillTypePicker = false
    },
    settlementAccount(){
      this.isSettlementAccount = true
      let user = store.state.sys.user;
      let params = {
        payer : user.userId
      }
      this.$axios.post(MyApi.FIN_SETTLEMENT_ACCOUNT,params).then((data) => {
        if('200' == data.code){
          this.$toast.success(data.msg);
        }
        this.isSettlementAccount = false

      }).catch((error) => {
        this.isSettlementAccount = false
        this.$toast.fail("轧账异常");
      })
    },
    //是否显示轧账数据
    checkUser(){
      let user = store.state.sys.user
      if(user.userId == BusiConsts.BELONG_BAO){
        return false;
      }
      return true;
    }

  }

};
</script>



<style>
.fin-panel {
  min-width: 120px;
  font-size: 20px;
  line-height: 36px;
  margin-left: 15px;
  margin-right: 15px;
  margin-bottom: 60px;
}

</style>
